import React, { Component } from 'react';
import { List, Toast, InputItem } from 'antd-mobile';
import * as services from '../../projects/services';
import { Button } from 'antd';
export class AddIntegral extends Component {

    constructor(props) {
        super(props);
        this.state = {
            fname: '新增健康积分卡',
            wait: 180,
            ishow: false,
            yz_show: false,
            yz_show2:true,
            m_user: [],
            rcode: '123456',
            HGuid: 0,
            parameter: {
                CardCode: '',
                IdNumber: '',
                Mobile: '',
                Password: '',
                MobileCode: '',
            }
        }
        this.handleChange = this.handleChangeCardCode.bind(this);
        this.handleChangeIdNumber = this.handleChangeIdNumber.bind(this);
        this.handleChangeMobile = this.handleChangeMobile.bind(this);
        this.handleChangePassword = this.handleChangePassword.bind(this);
        this.handleChangeMobileCode = this.handleChangeMobileCode.bind(this);
    }
    componentDidMount() {
        this.setState({ m_user: JSON.parse(localStorage.getItem('QUANREN_SSO_MM_USER_CACHE')) });
    }
    handleChangeCardCode = (e) => {
        let parameter = this.state.parameter;
        parameter.CardCode = e;
        this.setState({ parameter: parameter });
    }
    handleChangeIdNumber = (e) => {
        let parameter = this.state.parameter;
        parameter.IdNumber = e;
        this.setState({ parameter: parameter });
    }
    handleChangeMobile = (e) => {
        let parameter = this.state.parameter;
        parameter.Mobile = e;
        this.setState({ parameter: parameter });
    }
    handleChangePassword = (e) => {
        let parameter = this.state.parameter;
        parameter.Password = e;
        this.setState({ parameter: parameter });
    }
    handleChangeMobileCode = (event) => {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        let parameter = this.state.parameter;
        parameter.MobileCode = value;
        this.setState({ parameter: parameter });
    }
    onClose = () => { // 学习挣钱，调用父组件方法       
        this.props.onClose();
    }
    getTime = () => {
        if (this.state.wait === 0) {
            this.setState({  yz_show2: false });
        } else {
            let wait = this.state.wait;
            wait--;
            this.setState({ wait: wait });
            setTimeout(this.getTime, 1000);
        }
    }
    VerificationMobile() {
        var regex = /^1\d{10}$/;
        var idcardReg = /^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$|^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}([0-9]|X)$/;

        let parameter = this.state.parameter;
        if (!!parameter.CardCode === false) {
            Toast.offline('请输入健康积分卡号', 1);
            return false;
        }
        if (!!parameter.Password === false) {
            Toast.offline('请输入健康积分密码', 1);
            return false;
        }
        if (!!parameter.IdNumber === false || !idcardReg.test(parameter.IdNumber)) {
            Toast.offline('身份号码输入错误，请重新输入！', 1);
            return false;
        }
        if (!!parameter.Mobile === false || !regex.test(parameter.Mobile)) {
            Toast.offline('电话号码输入错误，请重新输入！', 1);
            return false;
        }
        return true;
    }
    SendCode = () => {
        if (!this.VerificationMobile()) {
            return false;
        }
        let parameter = this.state.parameter;
        let params = {
            mobile: parameter.Mobile
        }
        services.SendVerifyCode(params, '').then(data => {
            if (data.status === 0) {          
                Toast.success('发送成功，请在手机上查看验证码', 2);
                this.setState(
                    { HGuid: data.result.guid, sjyz_show: true ,ishow: true, yz_show: true,yz_show2: true,wait:180 },
                    () => {
                        this.getTime();
                    }
                );
            } else {
                Toast.offline(data.message);
            }
        });

    }
    cancel = () => {
        this.props.onClose();
    }
    AddBindCard = () => {
        let parameter = this.state.parameter;
        if (!this.VerificationMobile()) {
            return false;
        }
        
        if (!parameter.MobileCode) {
            Toast.offline('请输入正确的验证码！', 1);
            return false;
        }
        let parameter2 = { id: this.state.HGuid, code: parameter.MobileCode };
        services.CheckVerifyCode(parameter2, '').then(value => {
            if (value.result && value.status === 0) {                
                services.AddBindCard(parameter, '正在绑定，请稍后').then(data => {
                    if (data.status === 0) {
                        Toast.success(data.message, 1, () => {
                            this.onClose();
                            this.props.onload();
                          });
                      
                    } else {
                        Toast.offline(data.message);
                    }
                })
            } else {
                Toast.offline('验证码错误，请输入正确的验证码',1);
            }
        });
    }
    render() {
        const { ishow, yz_show, wait,yz_show2 } = this.state;
        return <div className="addaddress ">
            <List renderHeader={() => this.state.fname}>
                <InputItem
                    clear name="CardCode"
                    placeholder="健康积分卡号" onChange={this.handleChangeCardCode}
                    ref={el => this.refPublicId = el}
                >健康积分卡</InputItem>
                <InputItem
                    clear name="Password"
                    type="Password"
                    placeholder="积分卡密码" onChange={this.handleChangePassword}
                    ref={el => this.refPassword = el}

                >积分卡密码</InputItem>
                <InputItem
                    clear name="IdNumber"
                    placeholder="身份证号码" onChange={this.handleChangeIdNumber}
                    ref={el => this.refIdNumber = el}
                >身份证号码</InputItem>
                <InputItem
                    clear name="Mobile"
                    placeholder="手机号码" onChange={this.handleChangeMobile}
                    ref={el => this.refMobile = el}
                >手机号码</InputItem>
                <List.Item>
                    <span className="name">验&nbsp;&nbsp;&nbsp;证&nbsp;&nbsp;&nbsp;码</span><input className="shortInput" onChange={this.handleChangeMobileCode} name="vCode" type="tel" placeholder="验证码" /><Button className="yz" onClick={this.SendCode} disabled={yz_show}>获取验证码</Button>
                </List.Item>
            </List>
            {ishow ?
                <div className="sjyz_tip" >
                    如果3分钟内没有收到校验短信，您可以重新通过“短信”方式获取验证码，此服务免费。<Button  onClick={this.SendCode} disabled={yz_show2}>{wait === 0  ?  '重新获取短信':'('+ wait +' 秒后)重新获取短信'}</Button></div>
                : ''}
            <div className="butdiv"><Button onClick={this.cancel}>取消</Button><Button disabled={!ishow} className="ok" onClick={this.AddBindCard}>确定添加</Button></div>
        </div>
    }

}